if(!customElements.get('toggle-switch')){
    class ToggleSwitch extends HTMLElement {
        constructor() {
            super();
        }

        connectedCallback() {
            this.Initialize()
        }

        Initialize() {
            this.Group = this.dataset.toggleGroup
            this.Option = this.dataset.toggleOption
            this.addEventListener('click', this.HandleToggle)
        }
        HandleToggle(){
            const ToggleReceivers = document.querySelectorAll(`[data-toggle-group=${this.Group}]`)
            const OptionToggles = document.querySelectorAll(`[data-toggle-option=${this.Option}]`)
            ToggleReceivers.forEach((element) => element.dataset.state='InActive')
            OptionToggles.forEach((element) => element.dataset.state='Active')
        }
    }
    customElements.define('toggle-switch', ToggleSwitch);
}